import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { SearchComponent } from './search.component';
import { AgGridModule } from 'ag-grid-angular';
import { DatasetComponent } from './dataset/dataset.component';
import { MatTabsModule } from '@angular/material/tabs';
import { ExperimentComponent } from './dataset/experiment/experiment.component';
import { NgxFileDropModule } from 'ngx-file-drop';
import { FormsModule, ReactiveFormsModule} from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker'; 
import { MatNativeDateModule } from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { SamplesComponent } from './samples/samples.component';

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    AgGridModule,
    MatTabsModule,
    NgxFileDropModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatSelectModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatInputModule,
    SweetAlert2Module.forRoot()
  ],
  exports: [SearchComponent, DatasetComponent, ExperimentComponent],
  declarations: [SearchComponent, DatasetComponent, ExperimentComponent, SamplesComponent],
  providers: [],
})
export class SearchModule {}
